import React, { FC, useState } from 'react'

import { Modal, Txt, StandardButton, Icon } from 'src/components/atoms'

import { useGetCustomRoles, useUser } from 'src/hooks'
import { UserEntity } from 'src/types'

type Props = {
  users: UserEntity[]
  isOpen: boolean
  onClose: () => void
  afterDelete?: () => void
}

export const DeleteUserModal: FC<Props> = ({ users, isOpen, onClose, afterDelete }) => {
  const [isDeleting, setIsDeleting] = useState(false)
  const { deleteUser, isInternalUser } = useUser()
  const { refetch } = useGetCustomRoles()

  const handleOnDelete = async () => {
    setIsDeleting(true)

    try {
      await Promise.all(users.map(user => deleteUser({ userId: user.id })))
      // 1人でも社内ユーザーがいる場合、カスタムロールに属する人数が変わる場合があるため再取得する
      users.some(user => isInternalUser(user)) && (await refetch())
    } catch (error) {
      console.log('e: ', error)
    }

    afterDelete && afterDelete()
  }

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      maxWidth="md"
      headerInner={
        <div className="tw-px-s1">
          <div className="tw-flex tw-items-center">
            <Icon size="--r1" path="trash/soft/line" className="tw-accent-standardText-secondary" />
            <Txt sizeType="l" className="tw-ml-r-3 tw-font-bold">
              ユーザー削除
            </Txt>
          </div>
        </div>
      }
    >
      <div className="tw-w-[37.86rem] tw-p-s2">
        <Txt>
          作成したプロジェクトは削除されませんが、ユーザー削除を実行すると情報の復元はできません。本当によろしいですか？
        </Txt>

        <div className="tw-centering tw-mt-s3">
          <StandardButton
            buttonType="secondary"
            text="キャンセル"
            prependIconPath="close/soft/line"
            size="l"
            onClick={onClose}
          />
          <StandardButton
            buttonType="danger"
            text="削除する"
            prependIconPath="trash/soft/line"
            isLoading={isDeleting}
            size="l"
            onClick={handleOnDelete}
            className="tw-ml-s2"
          />
        </div>
      </div>
    </Modal>
  )
}
